export const createApplicationProduct = `
    mutation createApplicationProduct($input: CreateApplicationProductInput!) {
        createApplicationProduct(input:$input) {
          id
          applicationId
          productId
          product {
              id
              name
          }
          applicationProductStatus
          position
    }
}`;

export const updateApplicationProduct = `
    mutation updateApplicationProduct($input: UpdateApplicationProductInput!) {
        updateApplicationProduct(input:$input){
              id
              applicationId
              productId
              product {
                  id
                  name
              }
              applicationProductStatus
              position
        }
}`;

export const deleteApplicationProduct = `
    mutation deleteApplicationProduct($input: DeleteApplicationProductInput!) {
        deleteApplicationProduct(input:$input) {
            id
        }
}`;
